import { useEffect } from 'react'
import { useApiInterceptor } from '@/services/api'

export function useApi() {
  useApiInterceptor()
  
  useEffect(() => {
    // Setup is handled by the interceptor hook
  }, [])
}